import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import React from 'react';
import { Route } from 'react-router';

export const routes$ = {
    Index: AsyncPageRender(() => pageModule(import('./index'))),
};

function Router() {
    return (
        <>
            <Route exact path={'/operations/addons'} component={ProtectedRoute(routes$.Index)} />
        </>
    );
}

export default Router;
